import _ from "lodash";
import { DATA_GRID_COLUMN_TYPES } from "../constants";

const getCellStyles = ({
  currentNode,
  cellConfig,
  columnId,
  node,
  customConfig,
}) => {
  const { styles = {} } = cellConfig || {};
  const { isArchived = false } = currentNode?.metadata || {};
  const { property } = customConfig || {};

  const result = {
    ...styles,
    ...(isArchived ? { backgroundColor: "other" } : {}),
  };
  const value = _.get(node, property);

  switch (columnId) {
    case DATA_GRID_COLUMN_TYPES.TAGGED_IN_COURSES:
    case DATA_GRID_COLUMN_TYPES.TAGGED_IN_ASSIGNMENTS:
    case DATA_GRID_COLUMN_TYPES.TAGGED_IN_PORTFOLIO:
    case DATA_GRID_COLUMN_TYPES.TAGGED_IN_UNITS: {
      if (value < 1) result.color = "#8F8F8F";
      break;
    }
  }

  return result;
};

export default getCellStyles;
